import {useRouter} from "next/router";
import ArrowDownIcon from "images/icons/arrow_bottom.svg";
import styles from "components/sections/search/store/StoreSearchResult.module.scss";
import {useRef, useState} from "react";
import classNames from "classnames";
import {useClickAway} from "hooks/useClickAway";
import useTranslation from "next-translate/useTranslation";


export const KEY_RANK = 'rank';
export const KEY_SELL_COUNT = 'sell_count';
export const KEY_DISCOUNT_RATE = 'discount_rate';
export const KEY_RECENT = 'recent';
export const KEY_LOW_PRICE = 'low_price';
export const KEY_HIGH_PRICE = 'high_price';

const SORT_ORDER_KEYS = [
    KEY_RANK,
    KEY_SELL_COUNT,
    KEY_DISCOUNT_RATE,
    KEY_RECENT,
    KEY_LOW_PRICE,
    KEY_HIGH_PRICE,
];


const SortOrderModal = (props) => {
    const {sortOrder, targetRef, handleItemClick} = props;
    const router = useRouter();
    const {t} = useTranslation('sections-search-store-StoreSearchSortOrder')

    const handleClick = (key) => {
        typeof mixpanel !== 'undefined' && mixpanel.track('SortOrderModalItemClick', {key});
        router.replace(
            {query: Object.assign({}, router.query, {order: key})},
            undefined,
            {
                shallow: true,
                scroll: false,
            }
        );
        if (handleItemClick) {
            handleItemClick(key);
        }
    }

    return (
        <div className={styles.sortOrderModalContainer} ref={targetRef}>
            {
                SORT_ORDER_KEYS.map(key => {
                    return (
                        <div
                            key={`sort-order-${key}`}
                            className={classNames(styles.sortOrderRow, sortOrder === key && styles.isSelectedOrder)}
                            onClick={() => handleClick(key)}
                        >
                            <span>{t(`SortOrder.${key}`)}</span>
                        </div>
                    )
                })
            }
        </div>
    )

}

export const StoreSearchSortOrder = (props) => {
    const router = useRouter();
    const sortOrder = router.query.order || KEY_RANK;
    const {t} = useTranslation('sections-search-store-StoreSearchSortOrder')

    const [isModalOpen, setIsModalOpen] = useState(false);

    const closeBufferRef = useRef(false);

    const handleClick = () => {
        if (closeBufferRef.current) {
            return;
        }
        setIsModalOpen(v => !v);
    };

    const handleItemClick = (key) => {
        setIsModalOpen(false);
    };

    const modalRef = useClickAway((e) => {
        if (!isModalOpen) {
            return;
        }
        setIsModalOpen(false);
        closeBufferRef.current = true;
        setTimeout(() => {
            closeBufferRef.current = false;
        }, 300);
    });

    const sortOrderText = (key) => {
        return t('SortOrder.' + key);
    }

    return (
        <div className={styles.orderContainer}>
            {
                isModalOpen &&
                <SortOrderModal targetRef={modalRef} sortOrder={sortOrder} handleItemClick={handleItemClick}/>
            }
            <div className={styles.orderWrapper} onClick={handleClick}>
                <span className={styles.orderText}>{sortOrderText(sortOrder)}</span>
                <ArrowDownIcon className={styles.bottomIcon} viewBox="0 0 20 20"/>
            </div>
        </div>
    )
};
